import { CircularProgress } from '@mui/material';
import ReactDOM from 'react-dom';
import style from './bmp-portal.module.css';

const BmpPortal = () => {
  // Ensure the target element exists in the DOM
  const portalRoot = document.getElementById('portal');
  if (!portalRoot) {
    return null;
  }

  // Create a portal to render children into the portalRoot
  return ReactDOM.createPortal(
    <div className={style.reload}><CircularProgress /></div>,
    portalRoot
  );
};

export default BmpPortal;